import { IoTrashOutline } from "react-icons/io5"
import styles from "./styles.module.css"

import { ref, deleteObject } from "firebase/storage"
import { storage, database } from "../../../services/firebase-config"

import { useState } from "react"
import { doc, deleteDoc, updateDoc } from 'firebase/firestore'
import Loading from "../../Loading"


export default function BookRemoveButton({ collection, bookId, isVirtual, updateTableData }) {

    const [modal, setModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    async function disableBook(docCollection, docId) {
        setIsLoading(true);
        const documentRef = doc(database, docCollection, docId);
        await updateDoc(documentRef, { active: false })
        setModal(false);
        setIsLoading(false);
        updateTableData();
    }

    async function deleteBook(docCollection, docId) {
        setIsLoading(true);
        const documentRef = doc(database, docCollection, docId)
        if (isVirtual) {
            const storageBookRef = ref(storage, `${collection}/${docId}.epub`);
            await deleteObject(storageBookRef)
        }
        const storageImageRef = ref(storage, `images/${collection}/${docId}`);
        await deleteObject(storageImageRef)
        await deleteDoc(documentRef)
        setModal(false);
        setIsLoading(false);
        updateTableData();
    }

    return (<>
        <button title="Remover" className={styles.removeButton} onClick={() => { setModal(true) }}>
            <IoTrashOutline />
        </button>

        {modal &&
            <div className={styles.modalContainer}>
                <div className={styles.modalCard}>
                    {isLoading && <Loading />}
                    <h2 className={styles.modalCard__title}>Deletar</h2>
                    <p className={styles.modalCard__alert}>Tem certeza que deseja <strong>deletar</strong> este item?</p>
                    <div className={styles.modalCard__buttonsContainer}>
                        <button onClick={() => { setModal(false) }} className={styles.modalCard__closeButton}>Fechar</button>
                        <button onClick={() => { disableBook(collection, bookId) }} className={styles.modalCard__deleteButton}>Deletar</button>
                    </div>
                </div>
            </div>
        }

    </>);
}